import * as Yup from 'yup';

const EMAIL_REGEX = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;

export const validationPayment = Yup.object().shape({
  email: Yup.string()
    .required('Укажите электронную почту')
    .trim()
    .matches(EMAIL_REGEX, 'Некорректный формат почты'),
});
